/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import BackButton from 'components/Button/BackButton'
import { Box, Button, useDisclosure } from '@chakra-ui/react'
import { useSelector, useDispatch } from 'react-redux'
import SpinnerLoading from 'components/Loading/SpinnerLoading'
import { useTranslation } from 'react-i18next'
import 'katex/dist/katex.min.css'
import { useParams, useHistory } from 'react-router-dom'
import DisplayConfigPriority from './DisplayConfigPriority'
import * as actions from '../../../../redux/actions'

export default function ConfigPriority() {
  const { t, i18n } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)
  const [select, setSelect] = useState('GAUGE')
  const params = useParams()
  const station = useSelector((state) => state.station)
  const dispatch = useDispatch()
  const [isFetchNewOne, setisFetchNewOne] = useState(true)

  useEffect(() => {
    dispatch(actions.stationGet(params.id))
    setisFetchNewOne(false)
    setIsLoading(true)
    return () => {}
  }, [params, select, isFetchNewOne])

  const handleEditPriority = (data) => {
    console.log('data', data)

    let templateValue = station
    const checkRole = _.find(
      station?.priority,
      (pr) => pr?.role === params?.priority
    )
    const checkRoleIndex = _.findIndex(
      station?.priority,
      (pr) => pr?.role === params?.priority
    )
    const checkGauge = _.find(checkRole?.gauge, (e) => e === data?._id)
    const checkChart = _.find(checkRole?.chart, (e) => e === data?._id)
    const checkDiagram = _.find(checkRole?.diagram, (e) => e === data?._id)
    const arrayGauge = checkRole?.gauge
    const arrayChart = checkRole?.chart
    const arrayDiagram = checkRole?.diagram
    if (select === 'GAUGE') {
      if (!_.isEmpty(checkGauge) && !_.isEmpty(checkRole)) {
        _.remove(arrayGauge, (e) => e === data?._id)
        const dataSubmit = {
          role: params?.priority,
          gauge: arrayGauge,
          chart: station?.priority[checkRoleIndex]?.chart,
          diagram: station?.priority[checkRoleIndex]?.diagram,
        }
        templateValue.priority[checkRoleIndex] = dataSubmit
      } else if (_.isEmpty(checkRole)) {
        const dataSubmit = {
          role: params?.priority,
          gauge: data?._id,
          chart: station?.priority[checkRoleIndex]?.chart,
          diagram: station?.priority[checkRoleIndex]?.diagram,
        }

        templateValue.priority.push(dataSubmit)
        //console.log('arrayGauge', templateValue, dataSubmit, arrayGauge)
      } else {
        arrayGauge.push(data?._id)
        const dataSubmit = {
          role: params?.priority,
          gauge: arrayGauge,
          chart: station?.priority[checkRoleIndex]?.chart,
          diagram: station?.priority[checkRoleIndex]?.diagram,
        }

        templateValue.priority[checkRoleIndex] = dataSubmit
      }
    } else if (select === 'CHART') {
      if (!_.isEmpty(checkChart) && !_.isEmpty(checkRole)) {
        _.remove(arrayChart, (e) => e === data?._id)
        const dataSubmit = {
          role: params?.priority,
          gauge: station?.priority[checkRoleIndex]?.gauge,
          chart: arrayChart,
          diagram: station?.priority[checkRoleIndex]?.diagram,
        }
        templateValue.priority[checkRoleIndex] = dataSubmit
      } else if (_.isEmpty(checkRole)) {
        const dataSubmit = {
          role: params?.priority,
          gauge: station?.priority[checkRoleIndex]?.gauge,
          chart: data?._id,
          diagram: station?.priority[checkRoleIndex]?.diagram,
        }
        templateValue.priority.push(dataSubmit)
      } else {
        arrayChart.push(data?._id)
        const dataSubmit = {
          role: params?.priority,
          gauge: station?.priority[checkRoleIndex]?.gauge,
          chart: arrayChart,
          diagram: station?.priority[checkRoleIndex]?.diagram,
        }

        templateValue.priority[checkRoleIndex] = dataSubmit
      }
    } else if (select === 'DIAGRAM') {
      if (!_.isEmpty(checkDiagram) && !_.isEmpty(checkRole)) {
        _.remove(arrayDiagram, (e) => e === data?._id)
        const dataSubmit = {
          role: params?.priority,
          gauge: station?.priority[checkRoleIndex]?.gauge,
          chart: station?.priority[checkRoleIndex]?.chart,
          diagram: arrayDiagram,
        }
        templateValue.priority[checkRoleIndex] = dataSubmit
      } else if (_.isEmpty(checkRole)) {
        const dataSubmit = {
          role: params?.priority,
          gauge: station?.priority[checkRoleIndex]?.gauge,
          chart: station?.priority[checkRoleIndex]?.chart,
          diagram: data?._id,
        }

        templateValue.priority.push(dataSubmit)
      } else {
        arrayDiagram.push(data?._id)
        const dataSubmit = {
          role: params?.priority,
          gauge: station?.priority[checkRoleIndex]?.gauge,
          chart: station?.priority[checkRoleIndex]?.chart,
          diagram: arrayDiagram,
        }

        templateValue.priority[checkRoleIndex] = dataSubmit
      }
    }

    //console.log('templateValue', templateValue, data)

    dispatch(actions.stationPut(params.id, templateValue)).then(() => {
      dispatch(actions.stationGet(params.id))
    })

    setisFetchNewOne(true)
  }

  if (station && isLoading) {
    return (
      <div>
        <div className="relative  min-w-0 break-words bg-gray-100 w-full mb-6 shadow-lg rounded">
          <div className=" rounded-t mb-0 px-4 py-3 bg-transparent">
            <div className="flex flex-wrap items-center">
              <div className="relative w-full max-w-full flex-grow flex-1">
                <h6 className="uppercase text-gray-500 mb-1 text-xs font-semibold font-sans">
                  {t('setting.systemManagement')}
                </h6>
                <h6 className="text-gray-800 text-2xl font-bold font-sans">
                  {'สิทธิ์การเข้าถึง\n'}
                  {params?.priority === 'USER'
                    ? 'พนักงานทั่วไป'
                    : params?.priority === 'ADMIN'
                    ? 'พนักงานระดับหัวหน้า'
                    : params?.priority === 'MANAGER'
                    ? 'ผู้จัดการ'
                    : 'ผู้ดูแลระบบ'}
                </h6>
              </div>
            </div>
            <Button>
              <BackButton />
            </Button>
          </div>
          <div className="flex flex-wrap py-5">
            <div className="flex px-10">
              <div
                className={` ${
                  select === 'GAUGE' ? 'bg-gray-500' : 'bg-white'
                } shadow rounded py-4 px-10 transition-transform transform text-center hover:scale-105`}
                onClick={(event) => {
                  setSelect('GAUGE')
                }}
              >
                <i className="fa fa-solid fa-plus text-gray-800 text-center "></i>
                <p className=" text-gray-800 mb-0 text-center font-bold ">
                  เกจ
                </p>
              </div>
              <div className="flex justify-start gap-1 ">
                <div
                  className={` ${
                    select === 'CHART' ? 'bg-gray-500' : 'bg-white'
                  } shadow rounded py-4 px-10 transition-transform transform text-center hover:scale-105`}
                  onClick={(event) => {
                    setSelect('CHART')
                  }}
                >
                  <i className="fa fa-solid fa-plus text-gray-800 text-center "></i>
                  <p className=" text-gray-800 mb-0 text-center font-bold ">
                    กราฟ
                  </p>
                </div>
              </div>
              <div className="flex justify-start gap-1 ">
                <div
                  className={` ${
                    select === 'DIAGRAM' ? 'bg-gray-500' : 'bg-white'
                  } shadow rounded py-4 px-10 transition-transform transform text-center hover:scale-105`}
                  onClick={(event) => {
                    setSelect('DIAGRAM')
                  }}
                >
                  <i className="fa fa-solid fa-plus text-gray-800 text-center "></i>
                  <p className=" text-gray-800 mb-0 text-center font-bold ">
                    ไดอะแกรม
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="px-5">
            {
              <DisplayConfigPriority
                select={select}
                station={station}
                handleEditPriority={handleEditPriority}
              />
            }
          </div>
        </div>
      </div>
    )
  } else {
    return <SpinnerLoading />
  }
}
